import script from "./VideoAttachment.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoAttachment.vue?vue&type=script&setup=true&lang=ts"

import "./VideoAttachment.vue?vue&type=style&index=0&id=46d28437&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46d28437"]])

export default __exports__